import { useGroups } from '@entities/common/groups';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTempClientFormPageRedirect } from '@features/clients/client-form/ui/form/helpers.ts';
import { Add } from '@shared/assets';
import { useWindowWidth } from '@shared/hooks';
import { IconButton, MenuDropdown, MenuItem, useCommonMenu } from '@shared/ui';
import { openAddModal } from '@src/library/redux/modal';

type Props = {
  groupId: number;
  setAddUsers: (addUsers: boolean) => void;
  toggleSelectionMode: () => void;
};

export const AddUserMenu: React.FC<Props> = ({ groupId, setAddUsers, toggleSelectionMode }) => {
  // refactoring
  const { onOpen, onClose, setReferenceEl, referenceEl, popperEl, setPopperEl } = useCommonMenu();
  const { doSavePageUrl } = useTempClientFormPageRedirect();
  const navigate = useNavigate();
  const { resetSelectedGroups } = useGroups();

  const dispatch = useDispatch();
  const windowWidth = useWindowWidth();

  return (
    <>
      <IconButton
        key={`IconButton-${groupId}`}
        id={`button-${groupId}`}
        // onClick={onOpen}
        onClick={
          windowWidth <= 768
            ? () =>
                dispatch(
                  openAddModal({
                    title: 'Добавление клиента',
                    newText: 'Создать нового',
                    haveText: 'Добавить существующего',
                    newAction() {
                      doSavePageUrl();
                      resetSelectedGroups();
                      navigate('/clients/clients/edit/new', {
                        state: { groupId: groupId, path: window.location.pathname },
                      });
                    },
                    haveAction() {
                      navigate(`/clients/groups/addClients/${groupId}`);
                      toggleSelectionMode();
                    },
                  })
                )
            : onOpen
        }
        ref={(ref) => setReferenceEl(ref)}
        variant="dark"
      >
        <Add />
      </IconButton>
      <MenuDropdown
        id={groupId}
        referenceEl={referenceEl}
        popperEl={popperEl}
        setPopperEl={setPopperEl}
        key={`MenuDropdown-${groupId}`}
      >
        <MenuItem
          key={groupId + 'Создать нового'}
          onClick={(e) => {
            onClose(e);
            resetSelectedGroups();
            doSavePageUrl();
            navigate('/clients/clients/edit/new', {
              state: { groupId: groupId, path: window.location.pathname },
            });
            // navigate(`edit/new`, { state: window.location.pathname });
          }}
        >
          Создать нового
        </MenuItem>

        <MenuItem
          key={groupId + 'Добавить существующего'}
          onClick={(e) => {
            onClose(e);
            // setAddUsers(true);
            navigate(`/clients/groups/addClients/${groupId}`);
            toggleSelectionMode();
          }}
        >
          Добавить существующего
        </MenuItem>
      </MenuDropdown>
    </>
  );
};
